/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject, Injectable, OnDestroy } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { catchError, filter, takeUntil } from "rxjs/operators";
import {SwUpdate} from "@angular/service-worker";
import { Subject } from "rxjs";
import {EnvironmentService} from "@irian-ro/util-environment";

@Injectable()
export class ServiceWorkerVersionControlService implements OnDestroy {

  private isServiceWorkerActive = inject(EnvironmentService).getEnvironmentProperty('serviceWorker');

  private timestamp = 0;

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private router: Router, private swUpdate : SwUpdate) {
  }

  listenToRouterEvents() {
    if(this.isServiceWorkerActive) {
      this.router.events
        .pipe(
          filter(event => event instanceof NavigationStart),
          takeUntil(this.destroy$)
        )
        .subscribe({
          next: (navigationStart) => {
            this.checkForUpdates();
          }
        });
    }
  }

  checkForUpdates() {

    if (this.timestamp === 0 || Date.now() - this.timestamp > 1000) {

      this.timestamp = Date.now();
      this.swUpdate.checkForUpdate().then((isNewVersion) => {
        if(isNewVersion) {
          window.location.reload();
        }
      })
    } else {
      //do nothing
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

}
